<template>
  <PrimericaBenefits id="policy-benefits" :footer-content="footerContent">
    <!-- hero image -->
    <template #hero>
      <img
        :alt="$t('L_policy_protect_what_matters')"
        src="../../../assets/FamilyHavingFunAtHome1.jpg"
      />
      <h1 :aria-label="$t('L_policy_protect_what_matters')">
        {{ $t('L_policy_protect_what_matters') }}
      </h1>
    </template>
    <template v-slot:content>
      <v-container class="">
        <v-row class="px-2 px-sm-8 px-md-12 px-lg-16">
          <v-col cols="12">
            <h1 class="text-h2" :aria-label="$t('L_policy_buy_term')">
              {{ $t('L_policy_buy_term') }}
            </h1>
            <div class="pt-4 pb-8">
              <p>{{ $t('L_policy_primericas_philosophy') }}</p>
            </div>
            <VideoPlayer
              :video-url="$t('L_theory_of_decreasing_responsibility_videoUrl')"
              :closed-caption-url="$t('L_theory_of_decreasing_responsibility_closedCaptionUrl')"
              :poster-url="$t('L_theory_of_decreasing_responsibility_posterUrl')"
            />
          </v-col>
          <v-col cols="12">
            <h1 class="text-center text-h2 px-0" :aria-label="$t('L_policy_theory')">
              {{ $t('L_policy_theory') }}
            </h1>
            <p class="body-1 py-2">{{ $t('L_policy_according_to_theory') }}</p>
            <p class="body-1 py-2">{{ $t('L_policy_you_may_have_more_obligations') }}</p>
            <p class="body-1 py-2">{{ $t('L_policy_usually_have_fewer_financial') }}</p>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </PrimericaBenefits>
</template>

<script lang="ts">
import PrimericaBenefits from '@/components/PrimericaBenefits.vue';
import { defineComponent } from 'vue';
import { usePolicyStore } from '../store/policy.store';
import { mapState, mapStores } from 'pinia';
import { useCustomerStore } from '@/stores/customer/customer.store';
import VideoPlayer from '@/components/VideoPlayer/VideoPlayer.vue';
import icon4 from '@/assets/policies/icon4.svg';
import icon5 from '@/assets/policies/icon5.svg';
import icon6 from '@/assets/policies/icon6.svg';
import icon1 from '@/assets/policies/icon1.svg';
import icon2 from '@/assets/policies/icon2.svg';
import icon3 from '@/assets/policies/icon3.svg';

export default defineComponent({
  name: 'PolicyBenefitsTab',
  components: {
    PrimericaBenefits,
    VideoPlayer,
  },
  computed: {
    ...mapStores(usePolicyStore),
    ...mapState(useCustomerStore, ['customerProfile']),
    footerContent() {
      return {
        title: this.$t('L_policy_benefits_heading'),
        subtext: this.$t('L_disclaimer1_numbers_reflect_the_combined'),
        subtext2: this.$t('L_disclaimer2_the_following_companies_have'),
        subtext3: this.$t('L_disclaimer3_without_waiver_of_premium_terminal'),
        subtitle: this.$t('L_policy_benefits_subheading'),
        cards: [
          {
            icon: icon4,
            text: this.$t('L_policy_benefits_card_4'),
          },
          {
            icon: icon5,
            text: this.$t('L_policy_benefits_card_5'),
          },
          {
            icon: icon6,
            text: this.$t('L_policy_benefits_card_6'),
          },
          {
            icon: icon1,
            text: this.$t('L_policy_benefits_card_1'),
          },
          {
            icon: icon2,
            text: this.$t('L_policy_benefits_card_2'),
          },
          {
            icon: icon3,
            text: this.$t('L_policy_benefits_card_3'),
          },
        ],
      };
    },
  },
});
</script>

<style lang="scss">
#policy-benefits {
  .content {
    background: #fff;
    .video {
      margin: 40px 0;
    }
  }
}
</style>
